import React from 'react';
import FileUpload from './FileUpload';


const TestAdm01 = () => {
    const fUpAfter = (res, addOb) => {
        console.log('fUpAfter');
        console.log('res');
        console.log(res);
        console.log('addOb');
        console.log(addOb);      
    };

    const addOb = {
        par1: 'val1',
        par2: 'val2'
    };

    const fOpt = {
        upOnSel: true,
        multi: false,
        resizeOpt: {
            resizeType: 'w_h', 
            whMax: 150
        },
        // upFoldPath: 'up/dl-unit/',
        imAdd: {
            small: { 
                resizeOpt: { 
                    resizeType: 'w', 
                    whMax: 400, 
                    fNew: true, 
                    fNewNam: '', 
                    fNewNamSuf: '-m' 
                } 
            }
        },

    };
    return <div style={{ marginTop: '0em' }}>
        <div>
            test adm 01
        </div>
        <div>
            <FileUpload fOpt={ fOpt } fUpAfter={ fUpAfter } addOb={ addOb } />
        </div>
    </div>

}; 

export default TestAdm01;
